import { AxiosError, AxiosRequestConfig, AxiosResponse } from 'axios';

export default class CustomAxiosError<T = any> extends Error implements AxiosError {
    code?: string;
    config: AxiosRequestConfig = {};
    request: any;
    response?: AxiosResponse<T>;

    constructor(message: string, responseBody: AxiosResponse<T>) {
        super(message);
        this.response = responseBody;
    }
}
